import { render, staticRenderFns } from "./editMaterial.vue?vue&type=template&id=69423bf8&"
import script from "./editMaterial.vue?vue&type=script&lang=js&"
export * from "./editMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports